import { Component } from '@angular/core';

@Component({
  selector: 'app-bu-reports',
  templateUrl: './bu-reports.component.html',
  styleUrls: ['./bu-reports.component.scss'],
})
export class BuReportsComponent {}
